import { makeObservable, observable, action } from 'mobx';
import { getLoginStatus, logout } from '@service/login';

export default class Login {
  isLogin = false;

  userInfo: IUserInfo = {
    nickName: '', // 微信昵称
    avatar: '', // 头像
    countryCode: '', // 区号
    phone: '', // 手机号
    accountId: '',
    bindWechat: false, // 是否绑定微信号
    clientIp: '', // 客户端ip
  };

  constructor() {
    makeObservable(this, {
      isLogin: observable,
      userInfo: observable,
      changeIsLogin: action,
      changeUserInfo: action,
    });
  }

  // 更新登录状态
  changeIsLogin(bool) {
    this.isLogin = typeof bool === 'boolean' ? bool : Boolean(bool);
  }

  // 更新用户名称
  changeUserInfo(userInfo) {
    this.userInfo = { ...this.userInfo, ...userInfo };
  }

  // 获取用户登录状态
  getUserInfo = async () => {
    try {
      const {
        login: isLogin,
        avatarUrl: avatar,
        nickName,
        countryCode,
        phone,
        accountId,
        bindWechat,
        clientIp,
      } = await getLoginStatus();
      this.changeIsLogin(isLogin);
      this.changeUserInfo({ avatar, nickName, phone, countryCode, accountId, bindWechat, clientIp });
    } catch (err) {
      console.error(err);
    }
  };

  // 判断用户是否登录
  isLoginFn = async () => {
    try {
      const {
        login: isLogin,
        avatarUrl: avatar,
        nickName,
        phone,
        countryCode,
        accountId,
        bindWechat,
        clientIp,
      } = await getLoginStatus();
      if (isLogin) {
        this.changeIsLogin(true);
        this.changeUserInfo({ avatar, nickName, phone, countryCode, accountId, bindWechat, clientIp });
      } else {
        this.resetLoginStatus();
      }
      return isLogin;
    } catch (err) {
      return false;
    }
  };

  // 重置登录状态
  resetLoginStatus = () => {
    this.changeIsLogin(false);
    this.changeUserInfo({ nickName: '', avatar: '', bindWechat: false, accountId: '' });
  };

  // 退出登录
  userLogout = async () => {
    try {
      await logout();
      this.resetLoginStatus();
    } catch (err) {
      console.error(err);
    }
  };
}

export const LoginStore = new Login();
